import { doc, getDoc } from 'firebase/firestore';
import { db } from './config';

function isOfflineError(err) {
  return err?.code === 'unavailable' || err?.message?.includes('offline');
}

export const getUserProfile = async (uid) => {
  try {
    const userRef = doc(db, 'users', uid);
    const snapshot = await getDoc(userRef);
    if (!snapshot.exists()) return null;
    const d = snapshot.data();
    return d != null ? { id: snapshot.id, ...d } : null;
  } catch (err) {
    if (isOfflineError(err)) return null;
    throw err;
  }
};
